<div class="card">
  <div class="container" style="padding: 20px">
    <div class="row">
      <div class="col-sm" style="border-right: 3px dashed lightgray">
        <add-speech-form></add-speech-form>
      </div>
      <div class="col-sm">
        <add-author-form></add-author-form>
      </div>
    </div>
  </div>
</div>
